module.exports = __webpack_public_path__ + "static/media/main-visual-03-m.e902a95.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-03-m.mp4
// module id = 8qiF
// module chunks = 1